import React, { useState, useEffect } from "react";
import InputMessage from "./inputMessage";
import Navbar from "./NavBar";
import Messages from "./Messages";
import Spinner from "./../spinner";
import { ENDPOINT_MESSAGES } from "../../helpers/endpoints";
import axios from "../../helpers/axios";
import { useSelector, useDispatch } from "react-redux";
export default function Chat() {
  const { postId, title, urlImg, socket } = useSelector(state => ({
    ...state.Post,
    ...state.Socket
  }));
  const dispatch = useDispatch();
  const [messages, setMessages] = useState();
  const [loading, setIsLoading] = useState(false);
  const [loadingNext, setIsloadingNext] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const onClick = () => {
    dispatch({
      type: "TOGGLE"
    });
  };
  React.useEffect(() => {
    if (postId) {
      setMessages(null);
      setIsLoading(true);
      axios.get(ENDPOINT_MESSAGES(postId, 20, "")).then(({ data }) => {
        setMessages(data.messages);
        setHasNextPage(data.hasNextPage);
        setIsLoading(false);
      });
    }
  }, [postId]);

  React.useEffect(() => {
    if (messages && socket) {
      socket.on("message", message => {
        setMessages([message, ...messages]);
      });
    }
    return () => {
      if (socket) {
        socket.off("message");
      }
    };
  }, [messages, socket]);

  const sendMessage = message => {
    socket.emit("sendMessage", message);
  };
  const sendNotification = notification => {
    socket.emit("sendNotification", notification);
  };
  const nextPage = after => {
    setIsloadingNext(true);
    axios
      .get(ENDPOINT_MESSAGES(postId, 5, after))
      .then(({ data }) => {
        setMessages([...messages, ...data.messages]);
        setHasNextPage(data.hasNextPage);
        setIsloadingNext(false);
      })
      .catch(err => setIsloadingNext(false));
  };

  return (
    <div className="chat">
      <Navbar title={title} urlImg={urlImg} onClick={onClick} />

      {!loading && messages && (
        <Messages
          messages={messages}
          loading={loadingNext}
          hasNextPage={hasNextPage}
          nextPage={nextPage}
        />
      )}
      {!messages && loading && (
        <div className="initMessage">
          <Spinner />
        </div>
      )}
      {!messages && !loading && (
        <div className="initMessage">
          <div className="message">
            Welcome{" "}
            <img src={require("../../assets/img/socket-io.svg")} alt="" />
          </div>
        </div>
      )}
      {messages && !loading && (
        <InputMessage
          postId={postId}
          sendMessage={sendMessage}
          sendNotification={sendNotification}
        />
      )}
    </div>
  );
}
